export function cn(...classes: Array<string | false | null | undefined>) {
  const tokens: string[] = [];

  classes.forEach((value) => {
    if (!value) return;

    value
      .split(/\s+/)
      .filter(Boolean)
      .forEach((token) => {
        const existingIndex = tokens.lastIndexOf(token);
        if (existingIndex !== -1) {
          tokens.splice(existingIndex, 1);
        }
        tokens.push(token);
      });
  });

  return tokens.join(' ');
}
